var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('hero'),_c('vision',{attrs:{"articleId":"5fb3a0c034941d755a466008"}}),_c('geurs'),_c('part4'),_c('data-area'),_c('skills-area')],1)}
var staticRenderFns = []

export { render, staticRenderFns }